import React from "react"
import RegisterForm from "../components/auth/RegisterForm"

export default function RegisterPage() {
  return (
    <main className="max-w-7xl mx-auto px-4 py-8">
      <RegisterForm onSuccess={() => (window.location.href = "/panel")} />
    </main>
  )
}
